<template>
    <div class="my-2 d-flex justify-space-between">
        <span class="text-no-wrap mr-2">
            {{ name }}
        </span>
        <span class="text-right ml-auto font-weight-bold" style="word-wrap: break-word">
            {{ value }}
        </span>
    </div>
</template>

<script>
export default {
    props: {
        name: {
            type: String,
            default: null
        },
        value: {
            type: [String, Number],
            default: null
        }
    }
}
</script>